module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("application-confirmation-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "bulk-import-confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "backdrop": false,
      "width": "1100px",
      "value": _vm.showModal,
      "v-if": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.userDepartment))])])]), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-body bulk-import-confirmation-modal-body overflow-modal-body",
    style: ('height:300px' + _vm.model_height + 'px;padding: 5px 15px; ')
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("申請者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }), _vm._v(" "), (_vm.isUpdating) ? _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.teamApplicant))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userApplicant))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), (_vm.isUpdating) ? _c('td', {
    staticStyle: {
      "width": "10%"
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("承認者")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }), _vm._v(" "), (_vm.isUpdating) ? _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l(([1, 2, 3, 4, 5]), function(n) {
    return _c('tr', {
      key: n
    }, [_c('td', [_vm._v(_vm._s(n) + ".")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": _vm.lastChange
      }
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['team_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['team_' + n].id]
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['approver_' + n], {
          ignore_current_user: true
        }),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['approver_' + n].id]
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('field-box', {
      attrs: {
        "data": _vm.local_extend(_vm.localFields['status_' + n]),
        "read": _vm.readOnly,
        "val": _vm.values[_vm.localFields['status_' + n].id]
      }
    })], 1)]), _vm._v(" "), (_vm.isUpdating) ? _c('td', [_c('div', {
      staticClass: "col-xs-12"
    }, [(((_vm.localCurrentRow[_vm.localFields['status_' + n].id] == '未承認') || (_vm.localCurrentRow[_vm.localFields['status_' + n].id] == '' || (_vm.localCurrentRow[_vm.localFields['status_' + n].id] == null))) && _vm.localCurrentRow[_vm.localFields['approver_' + n].id] != _vm.userId) ? _c('button', {
      staticClass: "btn btn-danger btn-sm ",
      staticStyle: {
        "margin": "0px -15px",
        "height": "24px",
        "padding-top": "2px"
      },
      on: {
        "click": function($event) {
          _vm.localDeleteApplicant(n)
        }
      }
    }, [_vm._v("削除")]) : _c('button', {
      staticClass: "btn btn-danger disabled-application-button btn-sm ",
      staticStyle: {
        "margin": "0px -15px",
        "height": "24px",
        "padding-top": "2px"
      },
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("削除")])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.applicationMode != 'mode_inventory') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "col-xs-13"
  }, [_vm._v("最終承認")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-13"
  }, [_vm._v("ライセンス管理窓口（最終承認）")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col5), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col6), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer no_focus",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.approvalHistoryTorokuNumber))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalIsReadOnly == true && _vm.isUpdating == false && _vm.url_for_update != null && _vm.showStartUpdate == true),
      expression: "modalIsReadOnly == true && isUpdating == false  && url_for_update != null && showStartUpdate == true"
    }],
    class: 'btn btn-info ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disableBtnApply,
      "type": "button"
    },
    on: {
      "click": _vm.onLocalStartUpdate
    }
  }, [_vm._v("編集")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpdating == true),
      expression: "isUpdating == true"
    }],
    class: 'btn btn-info ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disableBtnApply,
      "type": "button"
    },
    on: {
      "click": _vm.onLocalStartUpdateSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalIsReadOnly != true),
      expression: "modalIsReadOnly != true"
    }],
    class: 'btn btn-primary ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": _vm.disableBtnApply,
      "type": "button"
    },
    on: {
      "click": _vm.onLocalApplication
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default ',
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "applicationConfirmatioModal"
    },
    on: {
      "done": _vm.onSaveApplicationConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformation"
    },
    on: {
      "done": _vm.onSave
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmUpdateApplicationInformation"
    },
    on: {
      "done": _vm.onUpdateConfirmed
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmUpdateApplicationInformationFinished"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b642b7b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/application-confirmation-modal.vue
// module id = 963
// module chunks = 0